module.exports = __webpack_public_path__ + "img/alternator.25d7e34f.png";